import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ProductGate } from '@bloo-team/core-shell'

/**
 * Vantage layout: the entitlement gate for every /vantage/* screen (D4).
 * One check covers all deep links into the product; unentitled sessions get
 * the guard page inside the shell, entitled ones never notice this route.
 */
function VantageLayout() {
  const { clusterId, scopeId } = Route.useParams()
  return (
    <ProductGate product="vantage" clusterId={clusterId} scopeId={scopeId}>
      <Outlet />
    </ProductGate>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage')({ component: VantageLayout })
